import type { FC } from 'react';

/**
 * The exclamation mark that sits beside the proud face on the collapsed banner's skill-earned state.
 *
 * Two marks from the design rather than a glyph: a slanted green bar over a peach dot. Typing "!" in
 * the banner's own font would give neither the tilt nor the two colours.
 *
 * Inline rather than an imported asset because the design handed these over as raw shapes, and
 * because the pair only means anything together — keeping them in one component stops the dot from
 * drifting away from its bar.
 */
export const InferredSkillExclamation: FC<{ className?: string }> = ({ className }) => (
  <span className={`tw-inline-flex tw-flex-col tw-items-center tw-gap-[3px] ${className ?? ''}`} aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
      <rect
        y="14.8994"
        width="17.4041"
        height="6.52653"
        rx="3.26327"
        transform="rotate(-58.8816 0 14.8994)"
        fill="#BDDA85"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      className="tw-relative tw-right-[8px]"
    >
      <ellipse cx="3.5" cy="3.5" rx="3.5" ry="3.5" transform="rotate(-180 3.5 3.5)" fill="#F9B7A3" />
    </svg>
  </span>
);

export default InferredSkillExclamation;
